import { commonSwal } from '../components/swalAlert/swalAlert';

export const errorAlert = (message) => {
    if(message === "Refresh token is not in database!" || message === "Invalid Refresh Token!"){
        window.location = '/lockscreen';
        return {
            status: "Failed",
            message: message
        }
    }

    commonSwal({notificationType: 'ERROR_ALERT', orderedMessage: message});

    return {
        status: "Failed",
        message: message
    }
}

export const badRequestError = (error) => {
    if (error.response) { 
        // status code out of the range of 2xx
        return errorAlert(error.response.status === 404 ? "File not Found" : error?.response?.data?.message);
    } else if (error.request) { 
        // The request was made but no response was received
        return errorAlert(error?.request);
    } else {
        // Error on setting up the request
        return errorAlert(error?.message);
    }
}